import { Button, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledConfrereButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'outlined' && prop !== 'applyTextTransform',
})(({ theme, outlined = false, applyTextTransform = true }) => ({
  color: outlined ? theme.palette.text.primary : theme.palette.text.secondary,
  backgroundColor: outlined
    ? theme.palette.secondary.main
    : theme.palette.primary.main,
  borderRadius: '60px',
  padding: '5px 16px 5px',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: outlined
      ? theme.palette.primary.main
      : theme.palette.secondary.main,
    color: outlined ? theme.palette.text.secondary : theme.palette.text.primary,
  },
  textTransform: applyTextTransform ? 'capitalize' : 'none',
}));

function ConfrereButton(props) {
  const { i18n } = useTranslation();

  // Check if the current language is English
  const isEnglish = i18n.language === 'en';

  return (
    // Pass the applyTextTransform prop based on the language
    <StyledConfrereButton {...props} applyTextTransform={isEnglish} />
  );
}

export default ConfrereButton;
